import axios from "./api";
class InterviewService {
  getAll() {
    return axios.get(`/interviews`);
  }
  get(id) {
    return axios.get(`/interviews/${id}`);
  }
  create(data) {
    return axios.post(`/interviews`, data);
  }
  update(id, data) {
    return axios.put(`/interviews/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/interviews/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InterviewService();
